const sanitizeImportedWorkspaceBaseName = (workspaceName) => {
    const normalized = String(workspaceName || '')
        .trim()
        .replace(/\.git$/i, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '');

    return normalized || 'imported_workspace';
};

export const sanitizeWorkspaceName = (workspaceName) => String(workspaceName || '').trim();

export const normalizeWorkspaceNameForComparison = (workspaceName) => {
    return sanitizeWorkspaceName(workspaceName)
        .replace(/\s+/g, ' ')
        .toLowerCase();
};

export const doesWorkspaceNameConflict = (workspaces = [], candidateWorkspaceName, excludeWorkspaceId = null) => {
    const normalizedCandidateName = normalizeWorkspaceNameForComparison(candidateWorkspaceName);
    if (!normalizedCandidateName) {
        return false;
    }

    return workspaces.some((workspace) => {
        if (!workspace || workspace.id === excludeWorkspaceId) {
            return false;
        }

        return normalizeWorkspaceNameForComparison(workspace.workspaceName) === normalizedCandidateName;
    });
};

export const deriveRepoBaseWorkspaceName = (repoUrl) => {
    const normalizedRepoUrl = String(repoUrl || '').trim().replace(/\/+$/, '');
    const repoName = normalizedRepoUrl.split('/').pop() || '';
    return sanitizeImportedWorkspaceBaseName(repoName);
};

export const formatWorkspaceImportTimestamp = (date = new Date()) => {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${month}-${day}-${year}-${hours}${minutes}`;
};

export const buildImportedWorkspaceName = (repoUrl, date = new Date()) => {
    return `${deriveRepoBaseWorkspaceName(repoUrl)}_${formatWorkspaceImportTimestamp(date)}`;
};